import React from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const on = () => setShow(window.scrollY > 400);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top"
      aria-label="Back to top"
      className="fixed bottom-24 right-6 z-40 h-11 w-11 flex items-center justify-center bg-navy text-white hover:bg-[#132644] transition-colors shadow-lg"
    >
      <ArrowUp size={16} />
    </button>
  );
}
